import React, { useState } from "react";
import { Alert, Box, Typography, Grid } from "@mui/material";
import { Add } from "@mui/icons-material";
import KrgButton, {
  BACKGROUND_ENUM,
  THEME_ENUM as BUTTON_THEME_ENUM,
  VARIANT_ENUM as BUTTON_VARIANT_ENUM,
} from "@kargo/shared-components.krg-button";

import { useFormContext } from "../../../context/form/form.provider";
import FormFieldRenderer from "../../../components/FormContextComponents/FormFieldRenderer";
import { PlaylistCreationEnum } from "../../../@types/playlist.types";
import AddVideosModal from "../../../components/Modals/AddVideosModal";
import { formatDuration } from "../../../helpers/videos";
import { Video } from "../../../api/types";

type SinglePlaylistEditorProps = {
  creationType?: PlaylistCreationEnum;
  onVideosAdded?: (videos: any[]) => void;
  mediaList: Video[];
};

/**
 * SinglePlaylistEditor
 * @constructor
 */
const SinglePlaylistEditor = ({
  creationType,
  onVideosAdded,
  mediaList,
}: SinglePlaylistEditorProps) => {
  const [{ formInputFields }] = useFormContext();
  const [isAddVideosModalOpen, setIsAddVideosModalOpen] = useState(false);

  const handleAddVideos = (selectedVideos: any[]) => {
    if (onVideosAdded) {
      onVideosAdded(selectedVideos);
    }
    setIsAddVideosModalOpen(false);
  };

  return (
    <Box id="media-editor-form-container">
      {Object.keys(formInputFields).map((key: string) => {
        const {
          [key]: { ...field },
        } = formInputFields;
        if (!field.name || key !== field.name) {
          return (
            <Box key={key}>
              <Alert severity="warning">
                {`Field: "${key}" don't match with name key: "${field.name}"`}
              </Alert>
            </Box>
          );
        }
        return <FormFieldRenderer key={key} name={key} type={field.type} />;
      })}
      {creationType === PlaylistCreationEnum.CUSTOM && (
        <>
          <Box sx={{ marginY: 2 }}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ marginBottom: 1 }}
            >
              Choose existing videos from your library to add to your playlist.
            </Typography>
            <KrgButton
              theme={BUTTON_THEME_ENUM.v2}
              variant={BUTTON_VARIANT_ENUM.outlined}
              style={{
                borderColor: BACKGROUND_ENUM.blue,
                color: BACKGROUND_ENUM.blue,
              }}
              startIcon={<Add />}
              text="ADD VIDEOS"
              onClick={() => setIsAddVideosModalOpen(true)}
            />
          </Box>
        </>
      )}

      {/* Add Videos Modal */}
      {creationType === PlaylistCreationEnum.CUSTOM && (
        <AddVideosModal
          isOpen={isAddVideosModalOpen}
          onClose={() => setIsAddVideosModalOpen(false)}
          onAddVideos={handleAddVideos}
          currentSelectedVideos={mediaList}
        />
      )}
      <Grid container spacing={2} sx={{ marginTop: "1px" }}>
        <Grid item xs={6} md={4} xl={3}>
          <Typography sx={{ fontSize: "11px" }}>Total Duration:</Typography>
          <Typography sx={{ fontSize: "16px" }}>
            {formatDuration(
              mediaList.reduce(
                (acc: number, media: Video) =>
                  acc + (media?.default_stream?.media_info?.duration || 0),
                0,
              ),
            )}
          </Typography>
        </Grid>
        <Grid item xs={6} md={4} xl={3}>
          <Typography sx={{ fontSize: "11px" }}>No of Videos:</Typography>
          <Typography sx={{ fontSize: "16px" }}>{mediaList.length}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SinglePlaylistEditor;
